import Indicator from '@components/Indicator';
import styled from '@emotion/styled';
import { BannerRow } from '@models/banner';
import { Fragment } from 'react';

interface Props {
    banners?: BannerRow[];
    index: number;
}

function BannerIndicator({ banners, index }:Props) {
    if ((banners?.length || 0) > 1) {
        return (
            <Wrapper>
                <Indicator total={banners?.length || 0}
                    current={index} />
            </Wrapper>
        );
    }
    return (<Fragment/>);
}

const Wrapper = styled.div`
    z-index: 2;
    position: absolute;
    bottom: calc(72px + var(--safe-area-bottom));
`;

export default BannerIndicator;
